import { MdOutlineAdd } from "react-icons/md";
import { IoIosUnlock, IoIosArrowRoundForward } from "react-icons/io";


const ButtonComponent = ({ name, type, disabled, className }) => {
  return (
    <div>
      {type === "delete" && <DeleteButton name={name} disabled={disabled} />}
      {type === "cancel" && <CancelButton name={name} disabled={disabled} />}
      {type === "add" && <AddButton name={name} disabled={disabled} />}
      {type === "login" && <LoginButton name={name} disabled={disabled} />}
      {type === "view" && (
        <ViewButton name={name} disabled={disabled} className={className} />
      )}
      {type === "book" && (
        <BookButton name={name} disabled={disabled} className={className} />
      )}
    </div>
  );
};

const DeleteButton = ({ name, disabled }) => {
  return (
    <button disabled={disabled} className="custom-button border-red-500 border-[1px] bg-red-500 text-white">
      {name}
    </button>
  );
};

const CancelButton = ({ name, disabled }) => {
  return (
    <button disabled={disabled} className="custom-button border-blue-500 border-[1px] text-white bg-blue-500">
      {name}
    </button>
  );
};

const AddButton = ({ name, disabled }) => {
  return (
    <button
      disabled={disabled}
      className="custom-button border-blue-500 border-[1px] text-white bg-blue-500 flex items-center space-x-2"
    >
      <div>
        <MdOutlineAdd size={20}/>
      </div>
      <div>{name}</div>
    </button>
  );
};

const LoginButton = ({ name, disabled }) => {
  return (
    <button
      disabled={disabled}
      className="custom-button border-blue-500 border-[1px] text-white bg-blue-500 flex items-center space-x-2"
    >
      <div>
        <IoIosUnlock size={20} />
      </div>
      <div>{name}</div>
    </button>
  );
};

const ViewButton = ({ name, disabled, className }) => {
  return (
    <button
      disabled={disabled}
      className={`custom-button border-color-gray-dark border-[1px] text-color-gray-dark uppercase font-bold text-lg flex items-center space-x-2 !px-10 w-full ${className}`}
    >
      <div>{name}</div>
      <div>
        <IoIosArrowRoundForward size={20} />
      </div>
    </button>
  );
};

const BookButton = ({ name, disabled, className }) => {
  return (
    <button
      disabled={disabled}
      className={`custom-button border-blue-700 bg-blue-700 border-[1px] text-color-white uppercase font-bold text-lg flex items-center space-x-2 !px-10 w-full ${className}`}
    >
      <div>{name}</div>
      {/* <div>
        <IoIosArrowRoundForward size={20} />
      </div> */}
    </button>
  );
};

export default ButtonComponent;
